import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SplashComponent } from './components/splash/splash.component';
import { FormComponent } from './components/form/form.component';



const routes: Routes = [
	{ path: 'new-patient', component: SplashComponent },
	{ path: 'form', component: FormComponent },
	{ path: '**', redirectTo: '/new-patient', pathMatch: 'full' },
]

@NgModule({
	imports: [RouterModule.forRoot(routes, {useHash: true})],
	exports: [RouterModule]
  })
  export class AppRoutingModule { }